(() => {
  'use strict';
  document.documentElement.classList.remove('no-js');
  const root = window.Shopify?.routes?.root || '/';
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const escapeHtml = (value = '') => String(value).replace(/[&<>"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[char]);
  let focusBeforeOverlay = null;
  const focusableSelector = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  const trapFocus = (event, container) => {
    if (event.key !== 'Tab' || !container) return;
    const focusable = $$(focusableSelector, container).filter((element) => element.offsetParent !== null);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  };

  const mobileMenu = $('[data-mobile-menu]');
  if (mobileMenu) mobileMenu.inert = true;
  const setMenu = (open) => {
    if (!mobileMenu) return;
    if (open) focusBeforeOverlay = document.activeElement;
    mobileMenu.classList.toggle('is-open', open);
    mobileMenu.setAttribute('aria-hidden', String(!open));
    mobileMenu.inert = !open;
    $('[data-menu-open]')?.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('no-scroll', open);
    if (open) $('[data-menu-close]', mobileMenu)?.focus();
    else if (focusBeforeOverlay instanceof HTMLElement) focusBeforeOverlay.focus();
  };
  $('[data-menu-open]')?.addEventListener('click', () => setMenu(true));
  $('[data-menu-close]')?.addEventListener('click', () => setMenu(false));
  $$('[data-localization-select]').forEach((select) => select.addEventListener('change', () => select.form?.submit()));

  const filterToggle = $('[data-filter-toggle]');
  const filterPanel = $('[data-filter-panel]');
  if (filterPanel) filterPanel.inert = true;
  filterToggle?.addEventListener('click', () => {
    const open = !filterPanel.classList.contains('is-open');
    filterPanel.classList.toggle('is-open', open);
    filterPanel.setAttribute('aria-hidden', String(!open));
    filterPanel.inert = !open;
    filterToggle.classList.toggle('is-open', open);
    filterToggle.setAttribute('aria-expanded', String(open));
    $('span', filterToggle).textContent = open ? '−' : '+';
  });
  $('[data-sort-select]')?.addEventListener('change', (event) => event.currentTarget.form?.submit());

  const money = (cents, pattern = '${{amount}}') => {
    const number = Number(cents || 0) / 100;
    const withDecimals = number.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const noDecimals = Math.round(number).toLocaleString();
    return pattern
      .replace(/{{\s*amount_no_decimals\s*}}/g, noDecimals)
      .replace(/{{\s*amount_with_comma_separator\s*}}/g, withDecimals.replace(/,/g, 'X').replace(/\./g, ',').replace(/X/g, '.'))
      .replace(/{{\s*amount\s*}}/g, withDecimals)
      .replace(/<[^>]*>/g, '');
  };

  const cartLayer = $('[data-cart-layer]');
  const cartDrawer = $('.cart-drawer', cartLayer || document);
  const cartContent = $('[data-cart-content]');
  const cartFooter = $('[data-cart-footer]');
  const cartMessage = $('[data-cart-message]');
  if (cartLayer) cartLayer.inert = true;
  const setCartOpen = (open) => {
    if (!cartLayer) return;
    if (open) focusBeforeOverlay = document.activeElement;
    cartLayer.classList.toggle('is-open', open);
    cartLayer.setAttribute('aria-hidden', String(!open));
    cartLayer.inert = !open;
    document.body.classList.toggle('no-scroll', open);
    if (open) $('[data-cart-close]', cartLayer)?.focus();
    else if (focusBeforeOverlay instanceof HTMLElement) focusBeforeOverlay.focus();
  };
  $$('[data-cart-open]').forEach((button) => button.addEventListener('click', () => setCartOpen(true)));
  $$('[data-cart-close]').forEach((button) => button.addEventListener('click', () => setCartOpen(false)));

  const cartLabels = {
    empty: cartDrawer?.dataset.labelEmpty || '',
    explore: cartDrawer?.dataset.labelExplore || '',
    remove: cartDrawer?.dataset.labelRemove || '',
    decrease: cartDrawer?.dataset.labelDecrease || '',
    increase: cartDrawer?.dataset.labelIncrease || '',
    error: cartDrawer?.dataset.labelError || '',
    shopUrl: cartDrawer?.dataset.shopUrl || '/collections/all'
  };
  const cartMoneyFormat = cartDrawer?.dataset.moneyFormat || '${{amount}}';

  const renderCart = (cart) => {
    $$('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
    if (!cartContent || !cartFooter) return;
    if (!cart.items.length) {
      cartContent.innerHTML = `<div class="empty-cart"><p>${escapeHtml(cartLabels.empty)}</p><a class="underlined-link" href="${escapeHtml(cartLabels.shopUrl)}">${escapeHtml(cartLabels.explore)}</a></div>`;
      cartFooter.classList.add('is-hidden');
      return;
    }
    cartContent.innerHTML = cart.items.map((item) => {
      const options = (item.options_with_values || []).map((option) => `<p>${escapeHtml(option.name)}: ${escapeHtml(option.value)}</p>`).join('');
      const imageUrl = item.image ? `${item.image}${item.image.includes('?') ? '&' : '?'}width=300` : '';
      const image = imageUrl ? `<img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(item.product_title)}" loading="lazy">` : '';
      return `<article class="cart-item" data-cart-line="${escapeHtml(item.key)}"><a class="cart-item-image" href="${escapeHtml(item.url)}">${image}</a><div><h3><a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a></h3>${options}<p>${escapeHtml(money(item.final_price, cartMoneyFormat))}</p><div class="quantity"><button type="button" aria-label="${escapeHtml(cartLabels.decrease)}: ${escapeHtml(item.product_title)}" data-cart-quantity="${item.quantity - 1}">−</button><span>${item.quantity}</span><button type="button" aria-label="${escapeHtml(cartLabels.increase)}: ${escapeHtml(item.product_title)}" data-cart-quantity="${item.quantity + 1}">+</button></div><button class="remove" type="button" data-cart-remove>${escapeHtml(cartLabels.remove)}</button></div></article>`;
    }).join('');
    $('[data-cart-subtotal]').textContent = money(cart.total_price, cartMoneyFormat);
    cartFooter.classList.remove('is-hidden');
  };

  const requestCart = async (url, options) => {
    if (cartMessage) cartMessage.textContent = '';
    try {
      const response = await fetch(url, options);
      const payload = await response.json();
      if (!response.ok) throw new Error(payload.description || 'Cart request failed');
      return payload;
    } catch (error) {
      if (cartMessage) cartMessage.textContent = cartLabels.error;
      return null;
    }
  };
  const refreshCart = async () => {
    const cart = await requestCart(`${root}cart.js`, { headers: { Accept: 'application/json' } });
    if (cart) renderCart(cart);
    return cart;
  };
  cartContent?.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cart-quantity],[data-cart-remove]');
    if (!button) return;
    const line = button.closest('[data-cart-line]');
    if (!line) return;
    const quantity = button.hasAttribute('data-cart-remove') ? 0 : Math.max(0, Number(button.dataset.cartQuantity));
    const cart = await requestCart(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: line.dataset.cartLine, quantity }) });
    if (cart) renderCart(cart);
  });

  $$('[data-product-root]').forEach((productRoot) => {
    const variants = JSON.parse($('[data-product-variants]', productRoot)?.textContent || '[]');
    const moneyFormat = JSON.parse($('[data-money-format]', productRoot)?.textContent || '"${{amount}}"');
    const form = $('[data-product-form]', productRoot);
    const optionGroups = $$('.variant-option', productRoot);
    const variantInput = $('[data-variant-id]', productRoot);
    const addButton = $('[data-add-to-cart]', productRoot);
    const addLabel = $('[data-add-label]', productRoot);
    const status = $('[data-selection-status]', productRoot);
    const price = $('[data-product-price]', productRoot);
    const comparePrice = $('[data-product-compare-price]', productRoot);
    const sku = $('[data-product-sku]', productRoot);
    const selected = optionGroups.map((group) => $('.variant-choice.selected', group)?.dataset.optionValue || '');
    const thumbs = $$('[data-gallery-thumb]', productRoot);
    let activeIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));

    const setMainImage = (src, alt = '') => {
      const mainImage = $('[data-gallery-main]', productRoot);
      if (!mainImage || !src) return;
      mainImage.removeAttribute('srcset');
      mainImage.src = src;
      mainImage.alt = alt;
      const backdrop = $('[data-gallery-backdrop]', productRoot);
      if (backdrop) backdrop.src = src;
    };
    const showMedia = (index) => {
      if (!thumbs.length) return;
      activeIndex = (index + thumbs.length) % thumbs.length;
      const thumb = thumbs[activeIndex];
      thumbs.forEach((item) => item.classList.toggle('is-active', item === thumb));
      setMainImage(thumb.dataset.mediaSrc, thumb.dataset.mediaAlt);
      const galleryIndex = $('[data-gallery-index]', productRoot);
      if (galleryIndex) galleryIndex.textContent = String(activeIndex + 1).padStart(2, '0');
    };
    const showVariantMedia = (variant) => {
      const featuredImage = variant?.featured_image;
      if (featuredImage?.src) {
        const imageId = String(featuredImage.id || '');
        const imageBase = featuredImage.src.split('?')[0];
        const matchingIndex = thumbs.findIndex((thumb) => thumb.dataset.mediaId === imageId || thumb.dataset.mediaSrc?.split('?')[0] === imageBase);
        if (matchingIndex >= 0) {
          showMedia(matchingIndex);
          return;
        }
        thumbs.forEach((thumb) => thumb.classList.remove('is-active'));
        setMainImage(`${featuredImage.src}${featuredImage.src.includes('?') ? '&' : '?'}width=1800`, featuredImage.alt || '');
        return;
      }

      const colorIndex = optionGroups.findIndex((group) => group.dataset.optionKind === 'color');
      const selectedColor = colorIndex >= 0 ? selected[colorIndex] : '';
      if (!selectedColor) return;
      const normalize = (value) => String(value || '').toLocaleLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
      const colorKey = normalize(selectedColor);
      const matchingIndex = thumbs.findIndex((thumb) => normalize(thumb.dataset.mediaAlt).includes(colorKey));
      if (matchingIndex >= 0) {
        showMedia(matchingIndex);
        return;
      }

      const configuredOrder = String(productRoot.dataset.mediaColorOrder || '').split(',').map((value) => value.trim()).filter(Boolean);
      const configuredIndex = configuredOrder.findIndex((value) => normalize(value) === colorKey);
      if (configuredIndex >= 0 && thumbs.length >= configuredOrder.length) {
        const mediaPerColor = Math.max(1, Math.floor(thumbs.length / configuredOrder.length));
        showMedia(Math.min(configuredIndex * mediaPerColor, thumbs.length - 1));
      }
    };

    const exactVariant = () => optionGroups.length ? variants.find((variant) => variant.options.every((value, index) => value === selected[index])) : variants[0];
    const previewVariant = () => variants.find((variant) => variant.available && selected.every((value, index) => !value || variant.options[index] === value));
    const updateChoices = () => optionGroups.forEach((group, index) => {
      $$('.variant-choice', group).forEach((choice) => {
        const possible = variants.some((variant) => variant.available && variant.options[index] === choice.dataset.optionValue && selected.slice(0, index).every((value, earlierIndex) => !value || variant.options[earlierIndex] === value));
        choice.disabled = !possible;
        choice.classList.toggle('selected', selected[index] === choice.dataset.optionValue);
        choice.setAttribute('aria-pressed', String(selected[index] === choice.dataset.optionValue));
      });
      const selectionLabel = $('[data-option-selection]', group);
      if (selectionLabel) selectionLabel.textContent = selected[index] || '';
    });
    const updateVariant = () => {
      const variant = exactVariant();
      const preview = variant || previewVariant();
      updateChoices();
      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (addLabel) addLabel.textContent = productRoot.dataset.labelSelect || '';
        if (status) status.textContent = productRoot.dataset.labelSelect || '';
        if (preview) {
          if (price) price.textContent = money(preview.price, moneyFormat);
          showVariantMedia(preview);
        }
        return;
      }
      if (variantInput) variantInput.value = variant.id;
      if (price) price.textContent = money(variant.price, moneyFormat);
      if (comparePrice) { comparePrice.textContent = variant.compare_at_price ? money(variant.compare_at_price, moneyFormat) : ''; comparePrice.hidden = !variant.compare_at_price; }
      if (sku) sku.textContent = variant.sku ? `${productRoot.dataset.labelSku || ''} ${variant.sku}`.trim() : '';
      if (addButton) addButton.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? `${addButton.dataset.labelAdd || ''} — ${money(variant.price, moneyFormat)}` : (addButton.dataset.labelSoldOut || '');
      if (status) { status.textContent = variant.available ? '' : (addButton.dataset.labelSoldOut || ''); status.classList.toggle('available', variant.available); }
      showVariantMedia(variant);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };
    optionGroups.forEach((group, index) => group.addEventListener('click', (event) => {
      const choice = event.target.closest('.variant-choice');
      if (!choice || choice.disabled) return;
      selected[index] = choice.dataset.optionValue;
      for (let laterIndex = index + 1; laterIndex < selected.length; laterIndex += 1) {
        if (!selected[laterIndex]) continue;
        const combinationExists = variants.some((variant) => variant.available && selected.slice(0, laterIndex + 1).every((value, optionIndex) => !value || variant.options[optionIndex] === value));
        if (!combinationExists) selected[laterIndex] = '';
      }
      updateVariant();
    }));
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showMedia(index)));
    $('[data-gallery-prev]', productRoot)?.addEventListener('click', () => showMedia(activeIndex - 1));
    $('[data-gallery-next]', productRoot)?.addEventListener('click', () => showMedia(activeIndex + 1));
    const lookbookTrack = $('[data-lookbook-track]', productRoot);
    const scrollLookbook = (direction) => lookbookTrack?.scrollBy({ left: direction * Math.max(300, lookbookTrack.clientWidth * 0.78), behavior: 'smooth' });
    $('[data-lookbook-prev]', productRoot)?.addEventListener('click', () => scrollLookbook(-1));
    $('[data-lookbook-next]', productRoot)?.addEventListener('click', () => scrollLookbook(1));
    updateVariant();

    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (addButton?.disabled) return;
      addButton.disabled = true;
      const payload = await requestCart(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (payload) { await refreshCart(); setCartOpen(true); }
      updateVariant();
    });
  });

  $$('[data-product-recommendations]').forEach((section) => {
    if (!section.dataset.url) return;
    const loadRecommendations = async () => {
      try {
        const response = await fetch(section.dataset.url, { headers: { Accept: 'text/html' } });
        if (!response.ok) return;
        const container = document.createElement('div');
        container.innerHTML = await response.text();
        const rendered = $('[data-product-recommendations]', container);
        if (rendered?.innerHTML.trim()) {
          section.innerHTML = rendered.innerHTML;
          section.classList.remove('is-pending');
        }
      } catch (_) {
        // Recommendations are optional; the product page remains complete without them.
      }
    };
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (!entries[0]?.isIntersecting) return;
        observer.disconnect();
        void loadRecommendations();
      }, { rootMargin: '0px 0px 300px 0px' });
      observer.observe(section);
    } else {
      void loadRecommendations();
    }
  });

  $$('[data-install-carousel]').forEach((carousel) => {
    const track = $('[data-install-track]', carousel);
    const cards = $$('.product-installation-guide__card', carousel);
    const status = $('[data-install-status]', carousel);
    if (!track || cards.length === 0) return;

    let pageIndex = 0;
    let autoplayTimer;
    const visibleCount = () => window.matchMedia('(max-width: 600px)').matches ? 1 : (window.matchMedia('(max-width: 900px)').matches ? 2 : 4);
    const pageCount = () => Math.ceil(cards.length / visibleCount());
    const updateStatus = () => {
      const first = pageIndex * visibleCount() + 1;
      const last = Math.min(first + visibleCount() - 1, cards.length);
      if (status) status.textContent = `${String(first).padStart(2, '0')}–${String(last).padStart(2, '0')} / ${String(cards.length).padStart(2, '0')}`;
    };
    const showPage = (nextPage, smooth = true) => {
      pageIndex = (nextPage + pageCount()) % pageCount();
      const target = cards[pageIndex * visibleCount()];
      track.scrollTo({ left: target?.offsetLeft || 0, behavior: smooth ? 'smooth' : 'auto' });
      updateStatus();
    };
    const stopAutoplay = () => window.clearInterval(autoplayTimer);
    const startAutoplay = () => {
      stopAutoplay();
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      autoplayTimer = window.setInterval(() => showPage(pageIndex + 1), 5500);
    };

    $('[data-install-prev]', carousel)?.addEventListener('click', () => { showPage(pageIndex - 1); startAutoplay(); });
    $('[data-install-next]', carousel)?.addEventListener('click', () => { showPage(pageIndex + 1); startAutoplay(); });
    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);
    carousel.addEventListener('focusin', stopAutoplay);
    carousel.addEventListener('focusout', startAutoplay);
    window.addEventListener('resize', () => showPage(0, false));
    showPage(0, false);
    startAutoplay();
  });

  document.addEventListener('keydown', (event) => {
    if (mobileMenu?.classList.contains('is-open')) {
      if (event.key === 'Escape') setMenu(false);
      else trapFocus(event, mobileMenu);
      return;
    }
    if (cartLayer?.classList.contains('is-open')) {
      if (event.key === 'Escape') setCartOpen(false);
      else trapFocus(event, cartDrawer);
    }
  });
})();
